import DownloadProgramThankYou from './DownloadProgramThankYou';

export default DownloadProgramThankYou;
